import { client } from './client';

export const getValues = () => client.get('/config');

export const getServerAlive = () =>
  client.get('/admin/login', { baseURL: client.defaults.baseURL.replace('/api', '') });
